import styled, { keyframes } from "styled-components";

// Animation
const headanimation = keyframes`
  to {
    background-position: 200% center;
  }
`;

export const LandingWrapper = styled.div`
  color: #fff;
  padding-top: 300px;
  height: 734px;
  width: auto;
  
  /* Set background image for screens larger than 768px */
  @media screen and (min-width: 768px) {
    background: url("assets/landing.png") no-repeat;
    background-size: 100% 100%;
  }
  
  /* Set background color for screens smaller than 768px */
  @media screen and (max-width: 767px) {
    background-color: #000;
  }
  
  /* Adjust height for screens smaller than 1440px */
  @media screen and (max-width: 1440px) {
    height: 600px;
  }
`;

export const LandingContainer = styled.div`
  max-width: 1200px;
  width: 95%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  gap: 40px;
`;

export const LandingHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 64px;
  line-height: 80px;
  text-align: center;
  background-image: linear-gradient(
    -225deg,
    #F06684 0%,
    #E11D48 29%,
    #E11D48 67%,
    #fff 100%
  );
  background-size: cover;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${headanimation} 5s linear infinite;
  @media screen and (max-width: 768px) {
    font-size: 45px;
    line-height: 60px;
  }
`;

export const LandingDesc = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
  width: 658px;
  max-width: 100%;
  text-align: center;
`;

export const LandingButton = styled.div`
  cursor: pointer;
  width: 290px;
  height: 60px;
  flex: none;
  order: 2;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #fff;
  background-color: #e11d48;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 170%;
  transition: all 0.3s;
  &:hover {
    color: #e11d48;
    border: 1px solid #e11d48;
    background-color: transparent;
  }
  @media screen and (max-width: 768px) {
    width: 40vw;
    min-width: 200px;
  }
`;
